import { Reorder, motion } from "framer-motion";
import { getSectionColor } from "projectSpecific/sports/create/sectionColors";
import { useEffect, useState } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { uniqueKey } from '../common/keys';
import Wrapper, { wrapperTypes } from "../wrappers/Wrapper";
import { convertHelpers } from "global/common/convert";

// const initialItems = ["🍅 Tomato", "🥒 Cucumber", "🧀 Cheese", "🥬 Lettuce"];

const initialItems = [
  { name: 'Test', _itemKey: 'test', other: 'xxx' },
  { name: 'BOOM', _itemKey: 'boom', other: 'yyy' }
]

const lblSize = 'mini'

const DragFramer = ({
  groupInfo,
  cn,
  allowSorting = true,
  axis = 'y',
  forSeeding,
  sorts,
  propsToShow = ['sections', 'badSeed'],
  handleReorder
}) => {

  const { group, caption, label } = groupInfo ?? {}

  const [currentItems, setCurrentItems] = useState([]);
  const [draggingItem, setDraggingItem] = useState();

  const addPropFromProp = (obj, existingProp, newProp) => {
    return _.mapValues(obj, (item) =>
      _.isObject(item)
        ? { ...item, [newProp]: _.get(item, existingProp) }
        : item
    );
  };

  useEffect(() => {
    const { dataItems, elements } = group ?? {}
    addPropFromProp(dataItems, 'id', '_itemKey')
    convertHelpers.createItemKeys(dataItems)
    if (dataItems) {
      const arrayData = _.map(dataItems, (value, key) => ({
        ...value,
        element: elements[key],
        key // Optionally, include the original key as a property in each object
      }));
      setCurrentItems(arrayData)
    } else {
      setCurrentItems(initialItems)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [group]);

  const handleSort = (sortItem) => {
    const { sortProp, sortOrder = 'asc' } = sortItem;
    const sortedDataItems = _.orderBy(currentItems, [sortProp], [sortOrder]).map((item, index) => ({
      ...item,
      position: index,
    }));
    setCurrentItems(sortedDataItems);
  };

  // const handleDragEnd = () => handleReorder(currentItems, groupInfo); 
  // const select = (groupKey) => selectionItems ? <Select key={uniqueKey('dd', 'dr', groupKey)} groupkey={groupKey} scrolling placeholder='Select' options={createNameItemList(selectionItems)} onChange={handleSelectChange} /> : null
  // const checker = (groupKey) => handleCheck ? <Checker checked={checkedItem === groupKey} handleClick={handleCheck} item={{ key: groupKey }} /> : null

  // const sorter = (sortItem) => <Icon
  //   key={uniqueKey('dfs', sortItem.name)}
  //   name={sortItem.icon}
  //   style={{ float: 'right' }}
  //   onClick={() => { handleSort(sortItem) }}
  // />

  const sorters = () => _.map(sorts, (sortItem) => (
    <Label size="tiny"> <Icon
      key={uniqueKey('dfs', sortItem.name)}
      name={sortItem.icon}
      style={{ float: 'right' }}
      onClick={() => { handleSort(sortItem) }}
    /></Label>
  ))

  const header_sort = () => <div className={'header-flex'} key={uniqueKey('dd', 'h')}>
    <div className='ln-flex'>
      {label && <Label size="tiny" color="black">{label}</Label>}
      <div>{caption}</div>
    </div>
    <div>
      {sorters()}
    </div>
  </div>

  const header_alignment = () => {
    const { hdd, levelKey, sectionKey } = group ?? {}
    return <div key={uniqueKey('dd', levelKey, sectionKey, 1)}
      className={'drop-group-header drd'}
    // style={headerColor ? { backgroundColor: headerColor } : {}}
    >
      <div key={uniqueKey('dda', levelKey, sectionKey, 2)}>{levelKey + ' - ' + _.startCase(sectionKey)} </div>
      <div key={uniqueKey('dda', levelKey, sectionKey, 3)}>{hdd}</div>
      {/* {select(groupKey)} */}
      {/* {checker(groupKey)} */}
      {sorts && sorters()}
      {/* {sorter()} */}
    </div>
  }

  const handle_onReorder = (items) => {
    // Update the list order and set new positions 
    const updatedDataItems = items.map((item, index) => ({
      ...item,
      position: index
    }));
    setCurrentItems(updatedDataItems);
    // handleReorder(updatedDataItems)

    // setTimeout(() => {
    // console.log('updatedDataItems', updatedDataItems)
    // handleReorder(updatedDataItems, groupInfo); // Call the passed-in function
    // }, 1000); // 1000ms delay (1 second)
  }


  const handle_dragEnd = (x) => {
    setDraggingItem(null)
    handleReorder(currentItems)
    // handleUpdateArray(currentDataItems)
  }

  const indexLabel = (index, badSeed) => <Label size={lblSize} color={badSeed ? getSectionColor(badSeed) : 'black'}>{index}</Label>

  const lbls_props = (item) => {
    const lbls = []
    _.forEach(propsToShow, (prop) => {
      if (item[prop]) {
        let value = item[prop]
        let color = 'grey';
        let unshft = false
        let circular = true
        switch (prop) {
          case 'sections':
            color = getSectionColor(value)
            value = value.replace('section', '')
            break;
          case 'badSeed':
            color = getSectionColor(value)
            value = value.replace('section', '')
            unshft = true
            circular = false
          default:
        }
        if (unshft) {
          lbls.unshift(<Label circular={circular} color={color} size="mini" >{value}</Label>)
        } else {
          lbls.push(<Label circular={circular} color={color} size="tiny" >{value}</Label>)
        }
      }
    })
    return <div>{lbls}</div>
  }

  const item_reorder = (item, idx, groupNumber) => {
    const { name, _itemKey, position, seed, badSeed } = item ?? {}
    let title = ''
    return <Reorder.Item
      title={title}
      key={_itemKey}
      value={item}
      as={motion.div}
      drag={allowSorting}
      onDragStart={() => setDraggingItem({ groupKey: groupNumber, _itemKey })}
      onDragEnd={() => handle_dragEnd(null)}
      dragConstraints={{ left: 0, right: 0 }}
      whileDrag={{
        scale: 1.05,
        boxShadow: "0 5px 10px rgba(0,0,0,0.2)",
      }}
      className={`group-item-drag${draggingItem?._itemKey === _itemKey ? ' dragging' : ''}`}
    >
      <div>
        {/* {indexLabel(seed, badSeed)} */}
        <Label size="tiny" color="blue">{seed || position}</Label>
        <div>{name}</div>
      </div>
      {propsToShow && lbls_props(item)}
    </Reorder.Item>
  }

  const content = () => <Reorder.Group
    className={'fm-rg ' + cn}
    axis={axis ? axis : 'y'}
    values={currentItems}
    onReorder={handle_onReorder}
  >
    {currentItems.map((item, idx) => (
      item_reorder(item, idx)
      // <DragFramerItem
      //   key={item._itemKey ? item._itemKey : item.id}
      //   item={item}
      //   label={forSeeding ? item.position + 1 : item.position}
      //   handleDragEnd={handleDragEnd}
      // />
    ))}
  </Reorder.Group>

  return <Wrapper
    header={caption ? header_sort() : header_alignment()}
    content={content()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

}

export default DragFramer